<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
        <Navbar />
        <div class="container-fluid">
            <SidebarSarpras/>
            <main class="main" id="main">
                <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '/sarpras/dashboard', text: 'Sarana dan Prasana'}, {url: '#', text: 'Generate Laporan Inspeksi'}]"/>
                <h2><b>Generate Laporan Inspeksi</b></h2>
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="generateReport">
                            <div class="row mb-3">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="start_month">Bulan Mulai <span class="text-danger">*</span></label>
                                        <input 
                                            type="month" 
                                            id="start_month"
                                            class="form-control" 
                                            v-model="form.start_month"
                                            required
                                        >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="end_month">Bulan Akhir <span class="text-danger">*</span></label>
                                        <input 
                                            type="month" 
                                            id="end_month"
                                            class="form-control" 
                                            v-model="form.end_month"
                                            required
                                        >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="format">Format <span class="text-danger">*</span></label>
                                        <select 
                                            id="format"
                                            class="form-control" 
                                            v-model="form.format"
                                            required
                                        >
                                            <option value="">Pilih Format</option>
                                            <option value="xls">Excel (CSV)</option>
                                            <option value="pdf">PDF</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button type="submit" class="btn btn-primary" :disabled="is_loading">
                                        <i class="fa fa-download"></i> Generate Report
                                    </button>
                                    <router-link to="/sarpras/dashboard" class="btn btn-secondary ms-2">
                                        <i class="fa fa-times"></i> Batal
                                    </router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Navbar from '../../../components/Navbar.vue'
import Breadcrumb from '../../../components/Breadcrumb.vue'
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import 'vue-loading-overlay/dist/vue-loading.css'
import SidebarSarpras from '../../../components/SidebarSarpras.vue'
import axios from 'axios'

export default {
    components: {
        Navbar,
        Loading,
        Breadcrumb,
        SidebarSarpras
    },
    data(){
        return {
            is_loading: false,
            form: {
                start_month: '',
                end_month: '',
                format: ''
            }
        }
    },
    methods: {
        generateReport(){
            if (!this.form.start_month || !this.form.end_month || !this.form.format) {
                this.$swal('Error', 'Mohon lengkapi semua field yang wajib diisi', 'error');
                return;
            }

            // Validate that end month is not before start month
            if (this.form.end_month < this.form.start_month) {
                this.$swal('Error', 'Bulan akhir tidak boleh sebelum bulan mulai', 'error');
                return;
            }

            this.is_loading = true;

            const params = {
                start_month: this.form.start_month,
                end_month: this.form.end_month,
                format: this.form.format
            };

            const fileExtension = this.form.format === 'pdf' ? 'pdf' : 'csv';
            const fileName = `laporan_inspeksi_${this.form.start_month}_${this.form.end_month}.${fileExtension}`;

            axios.get(`${this.$endpoints.sarpras}/inspections/report`, {
                params: params,
                responseType: 'blob'
            })
            .then(response => {
                const href = URL.createObjectURL(response.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.$swal('Success', 'Laporan berhasil diunduh', 'success');
            })
            .catch(error => {
                let errorMessage = 'Terjadi kesalahan saat mengunduh laporan';
                
                if (error.response) {
                    if (error.response.status === 404) {
                        errorMessage = 'Endpoint laporan tidak ditemukan';
                    } else if (error.response.status === 500) {
                        errorMessage = 'Terjadi kesalahan pada server';
                    } else if (error.response.data) {
                        // Try to extract error message from response
                        if (typeof error.response.data === 'string') {
                            errorMessage = error.response.data;
                        } else if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        }
                    }
                }
                
                this.$swal('Error', errorMessage, 'error');
            })
            .finally(() => {
                this.is_loading = false;
            });
        }
    },
    mounted(){
        // Set default values to current month
        const currentMonth = moment().format('YYYY-MM');
        this.form.start_month = currentMonth;
        this.form.end_month = currentMonth;
    }
}
</script>

<style scoped>
.form-group label {
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.text-danger {
    color: #dc3545;
}
</style>



